import React from 'react';
import { Input } from 'antd-mobile';
import './index.scss';

interface CommonInputProps {
  label: string;
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  maxLength?: number;
  errorMessage?: string;
  required?: boolean;
  validator?: (value: string) => boolean;
  type?: 'text' | 'number';
  readOnly?: boolean;
}

const CommonInput: React.FC<CommonInputProps> = ({
  label,
  value,
  onChange,
  placeholder = '',
  maxLength,
  errorMessage = '',
  required = true,
  validator,
  type = 'text',
  readOnly = false
}) => {
  // 处理输入变化
  const handleChange = (val: string) => {
    if (readOnly) {
      return;
    }

    // 如果有验证器，先验证
    if (validator && !validator(val)) {
      return;
    }
    
    // 如果是数字类型，只允许输入数字
    if (type === 'number') {
      const nonDigitRegex = /\D/;
      if (nonDigitRegex.test(val)) {
        return;
      }
    }
    
    onChange(val);
  };

  return (
    <div className="common-input-item">
      <div className={`common-input-label ${required ? 'required' : ''}`}>{label}</div>
      <div className="common-input-wrapper">
        <Input
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          maxLength={maxLength}
          readOnly={readOnly}
        />
        {errorMessage && <div className="common-input-error">{errorMessage}</div>}
      </div>
    </div>
  );
};

export default CommonInput;
